var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "disableShortcut",
      attrs: { id: "representative-settings" },
    },
    [
      _c(
        "a-tabs",
        {
          attrs: {
            "default-active-key": "1",
            "tab-position": _vm.mode,
            scrollable: "",
          },
        },
        [
          _c("a-tab-pane", { key: "1" }, [
            _c(
              "span",
              {
                attrs: { slot: "tab", title: _vm.$t("message.profile") },
                slot: "tab",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.profile").length > 20
                        ? _vm.$t("message.profile").substring(0, 20) + "..."
                        : _vm.$t("message.profile")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "containerKeyOne" },
              [
                _c(
                  "label",
                  { staticClass: "imgUpload" },
                  [
                    _vm.$_.get(_vm.user, "gravatar") === null &&
                    _vm.gravatar === null
                      ? _c("a-avatar", { attrs: { size: 84, icon: "user" } })
                      : _c("a-avatar", {
                          attrs: {
                            size: 84,
                            src:
                              _vm.gravatar || _vm.$_.get(_vm.user, "gravatar"),
                          },
                        }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "d-none",
                      attrs: { id: "profile-avatar", type: "file" },
                      on: { change: _vm.uploadFile },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "imgUploadOver" }, [_vm._v("+")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "emailAddress" }, [
                    _vm._v(_vm._s(_vm.$t("message.email"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "emailAddress" }, [
                    _vm._v(_vm._s(_vm.$_.get(_vm.user, "email"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "md-field",
                  { staticClass: "disableShortcut" },
                  [
                    _c("label", { staticClass: "md-fieldLabel" }, [
                      _vm._v(_vm._s(_vm.$t("message.username"))),
                    ]),
                    _vm._v(" "),
                    _c("md-input", {
                      staticClass: "disableShortcut mDinput",
                      model: {
                        value: _vm.user.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name", $$v)
                        },
                        expression: "user.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.changeUserName },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.updateUserName")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "2" },
            [
              _c(
                "span",
                {
                  attrs: {
                    slot: "tab",
                    title: _vm.$t("message.changePassword"),
                  },
                  slot: "tab",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("message.changePassword").length > 17
                          ? _vm.$t("message.changePassword").substring(0, 17) +
                              "..."
                          : _vm.$t("message.changePassword")
                      ) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "md-field",
                {
                  staticClass: "disableShortcut",
                  class: {
                    "md-invalid":
                      _vm.errors.first(_vm.$t("message.oldPassword")) != null,
                  },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.oldPassword", { num: "6" }))),
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:6",
                        expression: "'required|min:6'",
                      },
                    ],
                    ref: _vm.$t("message.password"),
                    staticClass: "disableShortcut",
                    attrs: {
                      name: _vm.$t("message.oldPassword"),
                      placeholder: _vm.$t("message.oldPassword", { num: "6" }),
                      autocomplete: "off",
                      trim: "",
                      type: "password",
                    },
                    model: {
                      value: _vm.oldPassword,
                      callback: function ($$v) {
                        _vm.oldPassword = $$v
                      },
                      expression: "oldPassword",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first(_vm.$t("message.oldPassword")))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-field",
                {
                  staticClass: "disableShortcut",
                  class: {
                    "md-invalid":
                      _vm.errors.first(_vm.$t("message.newPassword")) != null,
                  },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.newPassword", { num: "6" }))),
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:6",
                        expression: "'required|min:6'",
                      },
                    ],
                    ref: _vm.$t("message.password"),
                    staticClass: "disableShortcut",
                    attrs: {
                      name: _vm.$t("message.newPassword"),
                      placeholder: _vm.$t("message.passwordAtLeast", {
                        num: "6",
                      }),
                      autocomplete: "off",
                      trim: "",
                      type: "password",
                    },
                    model: {
                      value: _vm.newPassword,
                      callback: function ($$v) {
                        _vm.newPassword = $$v
                      },
                      expression: "newPassword",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first(_vm.$t("message.newPassword")))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-field",
                {
                  staticClass: "disableShortcut",
                  class: {
                    "md-invalid":
                      _vm.errors.first(_vm.$t("message.passwordRepeat")) !=
                      null,
                  },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.passwordRepeat"))),
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value:
                          "confirmed:" + _vm.$t("message.password") + "|min:6",
                        expression:
                          "'confirmed:' + $t('message.password') + '|min:6'",
                      },
                    ],
                    staticClass: "disableShortcut",
                    attrs: {
                      name: _vm.$t("message.passwordRepeat"),
                      autocomplete: "off",
                      type: "password",
                    },
                    model: {
                      value: _vm.passwordConfirmation,
                      callback: function ($$v) {
                        _vm.passwordConfirmation = $$v
                      },
                      expression: "passwordConfirmation",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first(_vm.$t("message.passwordRepeat")))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.changePassword },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.changePassword")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-tab-pane", { key: "3" }, [
            _c(
              "span",
              {
                attrs: {
                  slot: "tab",
                  title: _vm.$t("message.soundSettings"),
                  id: "notificationSettingsTab",
                },
                slot: "tab",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.soundSettings").length > 17
                        ? _vm.$t("message.soundSettings").substring(0, 17) +
                            "..."
                        : _vm.$t("message.soundSettings")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "containerKeyThree" }, [
              _c(
                "div",
                { staticClass: "sound-settings-container" },
                _vm._l(
                  [
                    "newVisitor",
                    "newConversation",
                    "assignedChat",
                    "newMessage",
                    "teamChatTeam",
                    "teamChatDm",
                    "teamChatDepartment",
                    "teamChatGroup",
                    "newAnnouncement",
                    "newTicketSound",
                  ],
                  function (i, ii) {
                    return _c(
                      "div",
                      {
                        key: ii,
                        staticClass: "sound-settings-element width-500",
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  placement: "top",
                                  zIndex: 1001,
                                },
                                expression:
                                  "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                              },
                            ],
                            staticClass: "sound-settings-title",
                            attrs: { content: _vm.vtippyMessages[ii] },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message." + i)) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-select",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  placement: "top",
                                  zIndex: 1001,
                                },
                                expression:
                                  "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                              },
                            ],
                            staticClass: "sound-settings-select",
                            attrs: {
                              content: _vm.$t(
                                "message.vtippySelectnotification"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.playPreviewSound(
                                  _vm.notificationSettings[ii]
                                )
                              },
                            },
                            model: {
                              value: _vm.notificationSettings[ii].soundFile,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.notificationSettings[ii],
                                  "soundFile",
                                  $$v
                                )
                              },
                              expression: "notificationSettings[ii].soundFile",
                            },
                          },
                          _vm._l(_vm.soundFiles, function (s) {
                            return _c(
                              "b-form-select-option",
                              { key: s, attrs: { value: s } },
                              [
                                _vm._v(
                                  _vm._s(s) + "\n                            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.notificationSettings[ii].audioLevel,
                              expression: "notificationSettings[ii].audioLevel",
                            },
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                placement: "top",
                                zIndex: 1001,
                              },
                              expression:
                                "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                            },
                          ],
                          attrs: {
                            id: i,
                            max: "100",
                            min: "0",
                            name: i,
                            step: "10",
                            type: "range",
                            content: _vm.$t("message.vtippyVoiceLevel"),
                          },
                          domProps: {
                            value: _vm.notificationSettings[ii].audioLevel,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.playPreviewSound(
                                _vm.notificationSettings[ii]
                              )
                            },
                            __r: function ($event) {
                              return _vm.$set(
                                _vm.notificationSettings[ii],
                                "audioLevel",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: i } }, [
                          _vm._v(
                            _vm._s(_vm.notificationSettings[ii].audioLevel) +
                              "%"
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  placement: "top",
                                  zIndex: 1001,
                                },
                                expression:
                                  "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                              },
                            ],
                            staticClass:
                              "md-icon-button md-primary play-sound-button",
                            attrs: {
                              content: _vm.$t("message.vtippyStartVoice"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.playPreviewSound(
                                  _vm.notificationSettings[ii]
                                )
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("play_circle")])],
                          1
                        ),
                        _vm._v(" "),
                        _vm.notificationSettings[ii].type === "new_chat"
                          ? _c(
                              "md-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      placement: "top",
                                      zIndex: 1001,
                                    },
                                    expression:
                                      "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                                  },
                                ],
                                staticClass:
                                  "md-icon-button md-primary play-sound-button",
                                attrs: {
                                  content: _vm.$t(
                                    "message.vtippyInfiniteNotification"
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.notificationSettings[ii].infinitePlay =
                                      !_vm.notificationSettings[ii].infinitePlay
                                  },
                                },
                              },
                              [
                                _c(
                                  "md-icon",
                                  {
                                    style: {
                                      color: !_vm.notificationSettings[ii]
                                        .infinitePlay
                                        ? "red"
                                        : "green",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "all_inclusive\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "desktop-notifications" }, [
                _c("div", { staticClass: "desktop-notifications-header" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z",
                          fill: "#5d5b8d",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("h3", { staticClass: "desktop-notifications-title" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("message.desktopNotifications")) +
                        "\n                        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "desktop-notifications-switches" },
                  _vm._l(
                    [
                      "newVisitor",
                      "newConversation",
                      "chatAssignedToUser",
                      "newMessage",
                      "newAnnouncement",
                      "newTicketSound",
                    ],
                    function (i, ii) {
                      return _c(
                        "div",
                        { key: ii, staticClass: "notification-card" },
                        [
                          _c("div", { staticClass: "notification-content" }, [
                            _c("div", { staticClass: "notification-icon" }, [
                              i === "newVisitor"
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z",
                                          fill: "#1890ff",
                                        },
                                      }),
                                    ]
                                  )
                                : i === "newConversation"
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM18 14H6V12H18V14ZM18 11H6V9H18V11ZM18 8H6V6H18V8Z",
                                          fill: "#52c41a",
                                        },
                                      }),
                                    ]
                                  )
                                : i === "chatAssignedToUser"
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M9 11.75C6.66 11.75 2 12.92 2 15.25V17H16V15.25C16 12.92 11.34 11.75 9 11.75ZM4.34 15C5.18 14.42 7.21 13.75 9 13.75C10.79 13.75 12.82 14.42 13.66 15H4.34ZM9 10C10.93 10 12.5 8.43 12.5 6.5C12.5 4.57 10.93 3 9 3C7.07 3 5.5 4.57 5.5 6.5C5.5 8.43 7.07 10 9 10ZM9 5C9.83 5 10.5 5.67 10.5 6.5C10.5 7.33 9.83 8 9 8C8.17 8 7.5 7.33 7.5 6.5C7.5 5.67 8.17 5 9 5ZM16.04 13.81C17.2 14.65 18 15.77 18 17H22V15.25C22 13.23 18.5 12.31 16.04 13.81ZM15 10C16.93 10 18.5 8.43 18.5 6.5C18.5 4.57 16.93 3 15 3C14.46 3 13.96 3.13 13.5 3.35C14.13 4.24 14.5 5.33 14.5 6.5C14.5 7.67 14.13 8.76 13.5 9.65C13.96 9.87 14.46 10 15 10Z",
                                          fill: "#faad14",
                                        },
                                      }),
                                    ]
                                  )
                                : i === "newMessage"
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z",
                                          fill: "#722ed1",
                                        },
                                      }),
                                    ]
                                  )
                                : i === "newAnnouncement"
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
                                          fill: "#eb2f96",
                                        },
                                      }),
                                    ]
                                  )
                                : _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z",
                                          fill: "#13c2c2",
                                        },
                                      }),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "notification-label" }, [
                              _vm._v(_vm._s(_vm.$t("message." + i))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("md-switch", {
                            staticClass: "md-primary notification-switch",
                            model: {
                              value:
                                _vm.notificationSettings[ii]
                                  .desktopNotification,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.notificationSettings[ii],
                                  "desktopNotification",
                                  $$v
                                )
                              },
                              expression:
                                "notificationSettings[ii].desktopNotification",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "notification-warning" }, [
                _c("img", {
                  staticClass: "notification-warning-img",
                  attrs: {
                    alt: _vm.$t("message.imageAltWarning"),
                    src: "https://static.supsis.live/secure.png",
                  },
                }),
                _vm._v(" "),
                _c("p", { staticClass: "notification-warning-text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.problemsSound")) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("a-tab-pane", { key: "4" }, [
            _c(
              "span",
              {
                attrs: {
                  slot: "tab",
                  title: _vm.$t("message.languageSettings"),
                },
                slot: "tab",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.languageSettings").length > 17
                        ? _vm.$t("message.languageSettings").substring(0, 17) +
                            "..."
                        : _vm.$t("message.languageSettings")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "containerKeyFour" }, [
              _c("label", { staticClass: "key-four-label" }, [
                _vm._v(_vm._s(_vm.$t("message.languageSettings")) + ":"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.lang,
                      expression: "lang",
                    },
                  ],
                  staticClass: "keyfour-select",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.lang = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.languages, function (lang) {
                  return _c(
                    "option",
                    { key: lang.code, domProps: { value: lang.code } },
                    [_vm._v(_vm._s(lang.originalName))]
                  )
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }